import { filterOutMultiLocJobs } from "../../js/helpers/multipleJobLocationHelpers";

export const FETCH_COMPANY_FEATURED_LOGOS = "FETCH_COMPANY_FEATURED_LOGOS";
export const FETCH_PROMOTED_SPONSORED_JOBS = "FETCH_PROMOTED_SPONSORED_JOBS";

export function fetchCompanyFeaturedLogos(logos) {
  return {
    type: FETCH_COMPANY_FEATURED_LOGOS,
    payload: logos,
  };
}

export function fetchPromotedSponsoredJobs(jobs) {
  return {
    type: FETCH_PROMOTED_SPONSORED_JOBS,
    payload: filterOutMultiLocJobs(jobs),
  };
}
